module.exports = __webpack_public_path__ + "97b40d433116797599b53744ddc0a668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RefreshIcon.svg
// module id = 699
// module chunks = 0